import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { RangeSliderComponent } from '../../range-slider-component';
import { StateController } from '../../../helpers/state/state-management/state-controller';
import topicData from '../../../helpers/state/topic-data';

@customElement('marker-cluster-settings')
export class MarkerClusterSettings extends LitElement {

    @property({ type: Boolean })
    open: boolean = false;

    @query('#markerClusterThreshold')
    markerClusterThreshold!: RangeSliderComponent;

    @query('#markerClusterMinimum')
    markerClusterMinimum!: RangeSliderComponent;

	private readonly bindTopicState = new StateController(this, topicData);

    async onChangeMarkerClusterThreshold(e: Event) {
        const threshold = (e.target as RangeSliderComponent).value;

        await topicData.fetchAndUpdateTopicData({
            marker_cluster_threshold: threshold
        }, 'marker cluster threshold', false, true);
    };

    async onChangeMarkerClusterMinimum(e: Event) {
        const minimum = (e.target as RangeSliderComponent).value;

        await topicData.fetchAndUpdateTopicData({
            marker_cluster_minimum: minimum
        }, 'marker cluster', false, true);
    };

    render() {
        return html`
            <h4 class="helpHeader">Marker Cluster Settings</h4>

            <p class="slider-header">
                Start-Clustering Threshold
                <form-tooltip
                    tipwidth="150px"
                    position="top"
                    leftPadding="30%"
                    message="When the number of points on your map exceeds this number, clustering will be enabled. Setting the limit too high may slow down the map's loading and performance."
                >
                    <mwc-icon>info</mwc-icon>
                </form-tooltip>
            </p>

            <range-slider-component
                id="markerClusterThreshold"
                min=${20}
                minString="20 Points"
                max=${1000}
                maxString="1000 Points"
                step=${25}
                .value=${topicData.topic?.marker_cluster_threshold ?? 0}
                @change=${this.onChangeMarkerClusterThreshold}
            ></range-slider-component>

            <p class="slider-header">
                Minimum Required Points per Cluster
                <form-tooltip
                    tipwidth="150px"
                    position="top"
                    leftPadding="30%"
                    message="After reaching the threshold, Proxi determines ${topicData.topic?.point_name ?? 'point'} clustering aggressiveness using this number. Setting it too high can impact map load speed.">
                    <mwc-icon>info</mwc-icon>
                </form-tooltip>
            </p>

            <range-slider-component
                id="markerClusterMinimum"
                min=${10}
                minString="10 (more clusters)"
                max=${200}
                maxString="200 (fewer clusters)"
                step=${5}
                .value=${topicData.topic?.marker_cluster_minimum ?? 50}
                @change=${this.onChangeMarkerClusterMinimum}
            ></range-slider-component>
        `;
    }

    static get styles() {
        return css`
            .slider-header {
                margin: 10px 0 0;
                color: var(--theme-lighter-text-color);
                display: flex;
                flex-direction: row;
            }
        `;
    }
}
